export const BASE_URL = process.env.REACT_APP_API_URL as string;

export const Api = {
  login: BASE_URL + "/auth/login",
  signup: BASE_URL + "/auth/signup",
  verifyEmail: BASE_URL + "/auth/verify-email",
  forgotPassword: BASE_URL + "/auth/forgot-password",
  confirmForgotPassword: BASE_URL + "/auth/confirm/forgot-password",
  resendConfirmationCode: BASE_URL + "/auth/resend/confirmation-code",
  changePassword: BASE_URL + "/auth/change-password",
  refreshToken: BASE_URL + "/auth/refresh-token",
  adminCreate: BASE_URL + "/auth/admin/create",
  adminResetPassword: BASE_URL + "/auth/admin/reset/password",
  dashboard: BASE_URL + "/dashboard",
  items: BASE_URL + "/items",
  user: BASE_URL + "/user",
  adminRestricted: BASE_URL + "/admin/restricted",
  adminNotRestricted: BASE_URL + "/admin/",
  adminCounts: BASE_URL + "/admin/restricted/counts",
  createCategory: BASE_URL + "/admin/restricted/category",
  searchItems: BASE_URL + "/dashboard/search",
  reviews: BASE_URL + "/reviews",
  updateCategory: BASE_URL + "/admin/restricted/category",
  getCategories: BASE_URL + "/admin/category",
  categories: BASE_URL + "/admin/category",
  searchCategories: BASE_URL + "/admin/restricted/category/search",
  warnUser: BASE_URL + "/admin/restricted/alert",
  broadcastAlert: BASE_URL + "/admin/restricted/broadcast",
  notification: BASE_URL + "/notification",
  unlistItem: BASE_URL + "/admin/restricted/unlist/item",
  chat: BASE_URL + "/chat",
};

export const DASHBOARD_PATH = "/";
export const CHAT_PATH = "/chat";
export const NOTIFICATIONS_PATH = "/notifications";
export const ITEMS_PATH = "/items";
export const ADMIN_PATH = "/admin";
export const ABOUT_PATH = "/about-us";
export const CONTACT_US_PATH = "/about-us#contact-us";
export const PRIVACY_POLICY_PATH = "/privacy-policy";
export const TERMS_AND_CONDITIONS_PATH = "/terms-and-conditions";
export const PRIVACY_DELETE_ACCOUNT_PATH = "/privacy-policy#delete-account";

/** sessionStorage key for post-login deep link resume */
export const PENDING_DEEP_LINK_KEY = "zelpye-pending-deep-link";

/** postMessage type from firebase-messaging-sw.js */
export const DEEP_LINK_MESSAGE_TYPE = "DEEP_LINK";

/** CustomEvent for in-app chat deep link navigation (App-level Ably handlers). */
export const CHAT_DEEP_LINK_EVENT = "zelpye-chat-deep-link";
